import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from './useAppRedux';
import { setLanguage } from '../redux/slices/appSlice';
import { getLanguageFromSearch } from '../seo/urls';

type AppLanguage = 'fa' | 'en';

export const useLanguageFromUrl = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const language = useAppSelector((state: { app: { language: AppLanguage } }) => state.app.language);

  useEffect(() => {
    const urlLanguage = getLanguageFromSearch(location.search) as AppLanguage;

    if (urlLanguage !== language) {
      dispatch(setLanguage(urlLanguage));
    }
  }, [dispatch, language, location.search]);

  const setLanguageInUrl = (nextLanguage: AppLanguage) => {
    dispatch(setLanguage(nextLanguage));

    const params = new URLSearchParams(location.search);

    if (nextLanguage === 'en') {
      params.set('lang', 'en');
    } else {
      params.delete('lang');
    }

    const search = params.toString();
    navigate(
      {
        pathname: location.pathname,
        search: search ? `?${search}` : ''
      },
      { replace: true }
    );
  };

  return {
    language,
    setLanguageInUrl
  };
};
